import script from "./MessageTicks.vue?vue&type=script&setup=true&lang=ts"
export * from "./MessageTicks.vue?vue&type=script&setup=true&lang=ts"

import "./MessageTicks.vue?vue&type=style&index=0&id=147f75af&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-147f75af"]])

export default __exports__